import { render } from "./NewsCarousel.vue?vue&type=template&id=47677386"
import script from "./NewsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__